import { Navigate, useParams } from "react-router-dom";
import { normalizeParticipantToken } from "../utils/legacyParticipantPaths";

/** Redirect legacy v1 participant URLs to the v2 assessment route. */
export default function LegacyInviteRedirect() {
  const { token: rawToken } = useParams();
  const token = normalizeParticipantToken(rawToken);
  if (!token) {
    return (
      <p className="p-8 text-center text-red-600">Invalid assessment link.</p>
    );
  }
  return <Navigate to={`/a/${token}`} replace />;
}
